/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
import axios from 'axios';
import {
    SEARCH_PAYEE,
    EDIT_PAYEE,
    GET_PAYEE_DETAILS_BY_ID,
    GET_PAYEE_FORM, ADD_PAYEE,
    UPDATE_PAYEE,
    SEARCH_PAYEE_BULK,
    PAYEE_BULK_FILE_UPLOAD,
    GET_BULK_PAYEE_DETAILS_BY_ID,
    UPDATE_PAYEE_BULK,
    UPDATE_BULK_PAYEE,
    SEARCH_PARENT_PAYEE,
    SEARCH_PARENT_PAYEE_REPORT,
    GET_PAYEE_HEIRARCHY,
    WITHDRAW_PAYEE,
    GET_ALL_PAYEE,
    SEARCH_BATCH_SUPPORTING_FILE,
    UPDATE_PAYMENT_STATUS,
    SEARCH_PENDING_PAYEE_BULK,
    SEARCH_ACTIONED_PAYEE_BULK,
    BULK_PAYEE_JOB_STATUS,
    EMAIL_NOTIFICATION,
    PAYEE_BULK_DEACTIVATE_SEARCH,
    PAYEE_BULK_DEACTIVATE_PENDING,
    PAYEE_BULK_DEACTIVATE_ACTIONED,
    PAYEE_BULK_DEACTIVATE_UPLOAD,
    PAYEE_BULK_DEACTIVATE_DETAILS,
    PAYEE_BULK_DEACTIVATE_APPROVAL,
    PAYEE_BULK_DEACTIVATE_WITHDRAW
} from './CONSTANTS';

import {
    encryptText, encryptJson, encryptUint8ArrayFile
} from '@utils/openpgp';

const config = { headers: { 'Content-Type': 'text/plain' } };

/**
 * Method is for searching payees
 * @param {object} data
 */
export const searchPayee = async data => (
    axios.post(SEARCH_PAYEE(), await encryptJson(data), config)
);

/**
 * Method is for searching payees
 * @param {object} data
 */
export const searchParentPayee = async data => (
    axios.post(SEARCH_PARENT_PAYEE(), await encryptJson(data), config)
);

/**
 * Method is for searching payees
 * @param {object} data
 */
export const searchPaymentReports = async data => (
    axios.post(SEARCH_PARENT_PAYEE_REPORT(), await encryptJson(data), config)
);

/**
 * Method is for getting payee details
 * @param {integer} id
 */
export const getPayeeDetails = id => (
    axios.get(GET_PAYEE_DETAILS_BY_ID(id))
);

/**
 * Method is for getting payee form data
 */
export const getPayeeFormData = () => (
    axios.get(GET_PAYEE_FORM())
);

/**
 * Method is for creating payee
 * @param {object} data
 * @param {boolean} proceedFlag
 * @param {Array} payeePortfoliosIds
 */
export const addPayee = async (data, proceedFlag, payeePortfoliosIds) => {
    const excludeKeys = ['oldFiles', 'code', 'primaryChannelId'];
    const formData = new FormData();
    for (const [key] of Object.entries(data)) {
        if (key === 'parentPayee') {
            formData.set(key, await encryptText(data[key].toString()));
        } else if (key === 'phoneNumber' && data.phoneNumber !== '') {
            const phonumberData = data.code === '' ? data.phoneNumber : `${data.code} ${data.phoneNumber}`;
            formData.append('phoneNumber', await encryptText(phonumberData));
        } else if (key === 'payeeFiles') {
            if (data.payeeFiles !== 0) {
                for (const file of data.payeeFiles) {
                    const encryptedFile = await encryptUint8ArrayFile(file);
                    formData.append('payeeSupportingDoc', encryptedFile, file.name);
                }
            }
        } else if (!excludeKeys.includes(key)) {
            const value = typeof data[key] === 'boolean' ? data[key].toString() : data[key];
            formData.set(key, await encryptText(value));
        }
    }

    if (proceedFlag) {
        formData.set('proceedFlag', await encryptJson(proceedFlag.toString()));
    }

    if (payeePortfoliosIds.length !== 0) {
        formData.append('payeePortfolios', await encryptJson(payeePortfoliosIds));
    }
    return Promise.resolve(axios.post(ADD_PAYEE(), formData));
};

/**
 * Method is for editing payee
 * @param {object} data
 * @param {integer} id
 * @param {boolean} proceedFlag
 * @param {Array} payeePortfoliosIds
 */
export const editPayee = async (data, id, proceedFlag, payeePortfoliosIds) => {
    const excludeKeys = ['code', 'primaryChannelId'];
    const formData = new FormData();
    formData.append('id', await encryptText(id));
    for (const [key] of Object.entries(data)) {
        if (key === 'parentPayee') {
            formData.set(key, await encryptText(data[key].toString()));
        } else if (key === 'phoneNumber' && data.phoneNumber !== '') {
            const phonumberData = data.code === '' ? data.phoneNumber : `${data.code} ${data.phoneNumber}`;
            formData.append('phoneNumber', await encryptText(phonumberData));
        } else if (key === 'payeeFiles') {
            if (data.payeeFiles !== 0) {
                for (const file of data.payeeFiles) {
                    const encryptedFile = await encryptUint8ArrayFile(file);
                    formData.append('payeeSupportingDoc', encryptedFile, file.name);
                }
            }
        } else if (key === 'oldFiles') {
            const fileIds = [];
            data.oldFiles.forEach(oldFile => fileIds.push(oldFile.id));
            if (fileIds.length !== 0) {
                formData.append('payeeFileIds', await encryptJson(fileIds));
            }
        } else if (!excludeKeys.includes(key)) {
            const value = typeof data[key] === 'boolean' ? data[key].toString() : data[key];
            formData.set(key, await encryptText(value));
        }
    }
    if (proceedFlag) {
        formData.set('proceedFlag', await encryptJson(proceedFlag.toString()));
    }
    if (payeePortfoliosIds.length !== 0) {
        formData.append('payeePortfolios', await encryptJson(payeePortfoliosIds));
    }
    return Promise.resolve(axios.post(EDIT_PAYEE(), formData));
};

/**
 * Method is for withdrawing payee
 * @param {integer} id
 * @param {string} statusName
 */
export const withdrawPayee = async (id, statusName) => {
    const formData = new FormData();
    formData.set('id', await encryptText(id));
    formData.set('statusName', await encryptText(statusName));
    return Promise.resolve(axios.post(WITHDRAW_PAYEE(), formData));
};

/**
 * Method is for updating status of payee [reject and approve payee]
 * @param {object} data
 */
export const updatePayeeData = async data => {
    const formData = new FormData();
    formData.set('id', await encryptText(data.id));
    formData.set('comment', await encryptText(data.comments));
    formData.set('statusName', await encryptText(data.status));
    formData.set('isApproved', await encryptText((data.isApproved).toString()));
    const files = data.supportingDoc;
    if (files && files.length !== 0) {
        // eslint-disable-next-line no-restricted-syntax
        for (const file of files) {
            const encryptedFile = await encryptUint8ArrayFile(file);
            formData.append('payeeSupportingDoc', encryptedFile, file.name);
        }
    }
    return Promise.resolve(axios.post(UPDATE_PAYEE(), formData));
};

/**
 * Method is for getting all payees
 */
export const getAllPayees = () => (
    axios.get(GET_ALL_PAYEE())
);

/* ************************** Methods for bulk payee **************************** */

/**
 * Method is for searching bulk payees
 * @param {object} data
 */
export const searchPayeeBulk = async data => (
    axios.post(SEARCH_PAYEE_BULK(), await encryptJson(data), config)
);

export const searchPendingPayeeBulk = async data => (
    axios.post(SEARCH_PENDING_PAYEE_BULK(), await encryptJson(data), config)
);

export const searchActionedPayeeBulk = async data => (
    axios.post(SEARCH_ACTIONED_PAYEE_BULK(), await encryptJson(data), config)
);

/**
 * Method is for getting bulk payee details
 * @param {integer} id
 */
export const getBulkPayeeDetails = id => (
    axios.get(GET_BULK_PAYEE_DETAILS_BY_ID(id))
);

/**
 * Method is for uploading bulk payees file
 * @param {object} data
 * @param {integer} id
 */
export const payeeBulkFileUpload = async (data, id, isDeactivateMode = false) => {
    const formData = new FormData();
    if (id) {
        formData.set('id', await encryptText((id).toString()));
    }
    formData.set('name', await encryptText(data.name));
    formData.set('comment', await encryptText(data.comment));
    if (data.bulkpayeeFile.id) {
        formData.set('bulkpayeeFileId', await encryptText((data.bulkpayeeFile.id).toString()));
    } else {
        formData.append('bulkpayeeFile', await encryptUint8ArrayFile(data.bulkpayeeFile), data.bulkpayeeFile.name);
    }
    const files = data.bulkPayeeSupportingDoc;
    if (files.length !== 0) {
        for (const file of files) {
            const encryptedFile = await encryptUint8ArrayFile(file);
            formData.append('bulkPayeeSupportingDoc', encryptedFile, file.name);
        }
    }
    if (data.oldFiles) {
        const fileIds = [];
        data.oldFiles.forEach(oldFile => fileIds.push(oldFile.id));
        if (fileIds.length !== 0) {
            formData.append('supportingDocsIds', await encryptJson(fileIds));
        }
    }

    const api = isDeactivateMode ? PAYEE_BULK_DEACTIVATE_UPLOAD() : PAYEE_BULK_FILE_UPLOAD();
    return axios.post(api, formData);
};

/**
 * @param {object} id
 * @param {string} statusName
 */
export const withdrawBulkPayee = async (id, statusName, isDeactivateMode = false) => {
    const data = { id, statusName };
    const api = isDeactivateMode ? PAYEE_BULK_DEACTIVATE_WITHDRAW() : UPDATE_PAYEE_BULK();
    return Promise.resolve(axios.post(api, await encryptJson(data), config));
};

/**
 * Method is for updating status of bulk payee [reject and approve bulk payee]
 * @param {object} data
 */
export const updateBulkPayee = async data => {
    const formData = new FormData();
    formData.set('id', await encryptText((data.id).toString()));
    formData.set('comment', await encryptText(data.comments));
    formData.set('statusName', await encryptText(data.status));
    const files = data.supportingDoc;
    if (files && files.length !== 0) {
        // eslint-disable-next-line no-restricted-syntax
        for (const file of files) {
            const encryptedFile = await encryptUint8ArrayFile(file);
            formData.append('bulkPayeeSupportingDoc', encryptedFile, file.name);
        }
    }
    return Promise.resolve(axios.post(UPDATE_BULK_PAYEE(), formData));
};

/**
 * Method is for searching payees
 * @param {object} data
 */
export const getPayeeheirarchy = async data => (
    axios.post(GET_PAYEE_HEIRARCHY(), await encryptJson(data), config)
);

/**
 * Method is for getting list of supporting files for payee statement
 * @param {object} data
 */
export const getBatchSupportingFilesList = async data => (
    axios.post(SEARCH_BATCH_SUPPORTING_FILE(), await encryptJson(data), config)
);

/**
 * Method is for approving payment
 * @param {integer} batchFileId
 * @param {string} status
 * @param {integer} batchId
 * @param {string} comment
 */
export const updatePaymentStatus = async data => (
    axios.post(UPDATE_PAYMENT_STATUS(), await encryptJson(data), config)
);

/**
 * Method is for getting payee details
 * @param {integer} id
 */
export const getBulkPayeeJobStatus = id => (
    axios.get(BULK_PAYEE_JOB_STATUS(id))
);

export const sendEmailNotification = async (id) => {
    const data = { id };
    return Promise.resolve(axios.post(EMAIL_NOTIFICATION(), await encryptJson(data), config));
};

export const searchPayeeBulkDeactivate = async data => (
    axios.post(PAYEE_BULK_DEACTIVATE_SEARCH(), await encryptJson(data), config)
);

/**
 * Method is for searching pending payees
 * @param {object} data
 */
export const getPendingPayeeBulkDeactivate = async data => (
    axios.post(PAYEE_BULK_DEACTIVATE_PENDING(), await encryptJson(data), config)
);

/**
 * Method is for getting bulk deactivate details
 * @param {integer} id
 */
export const getPayeeBulkDeactivateDetails = id => (
    axios.get(PAYEE_BULK_DEACTIVATE_DETAILS(id))
);

/**
 * Method is for searching actioned payees
 * @param {object} data
 */
export const getActionedPayeeBulkDeactivate = async data => (
    axios.post(PAYEE_BULK_DEACTIVATE_ACTIONED(), await encryptJson(data), config)
);

/**
 * Method is for updating status of bulk payee [reject and approve bulk deactivate]
 * @param {object} data
 */
export const approvePayeeBulkDeactivate = async data => {
    const formData = new FormData();
    formData.set('id', await encryptText((data.id).toString()));
    formData.set('comment', await encryptText(data.comments));
    formData.set('statusName', await encryptText(data.status));
    const files = data.supportingDoc;
    if (files && files.length !== 0) {
        // eslint-disable-next-line no-restricted-syntax
        for (const file of files) {
            const encryptedFile = await encryptUint8ArrayFile(file);
            formData.append('bulkPayeeSupportingDoc', encryptedFile, file.name);
        }
    }
    return Promise.resolve(axios.post(PAYEE_BULK_DEACTIVATE_APPROVAL(), formData));
};